module.exports = {"unsupportedBrowser":"This browser is not supported.","checkIdPw":"Please check your ID and password.","greenTempFileName":"Green Temperature by Period"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/routermsg.json
// module id = vAMV
// module chunks = 2